import Providers from "./providers";
import Routes from "routes";
import OneSignal from "react-onesignal";
import {useEffect} from "react";

export default function App() {

  useEffect(() => {

    // OneSignal init
    const isAllowedDomain =
        window.location.hostname === 'app.bonifi.ca' ||
        window.location.hostname === 'localhost';

    const appId = process.env.REACT_APP_ONESIGNAL_APP_ID

    if (isAllowedDomain && window.OneSignal && typeof window.OneSignal.init === 'function') {
      OneSignal.init({
        appId: appId,
        safari_web_id: "web.onesignal.auto.02091d44-51df-4a38-967b-45e7d1e7feaf",
        allowLocalhostAsSecureOrigin: true,
        notifyButton: { enabled: false },
        welcomeNotification: { disable: true }
      });
    }

  }, [])

  return (
  <Providers>
    <Routes />
  </Providers>
  )
}
